import { useTranslation } from 'react-i18next'
import { Signature, Header } from '~/entities/Inspection'
import { ThumbType } from '~/shared/api'
import { Title } from './styled'

type SignatureStepProps = {
  isSubmitting: boolean
  onSuccess: (sign: ThumbType) => void
}

export function SignatureStep({ isSubmitting, onSuccess }: SignatureStepProps) {
  const { t } = useTranslation()

  return (
    <>
      <Header title={t('drivers signature')} />
      <Title>
        {t(
          'i am familiar with the inspection results and confirm the identified damages',
        )}
      </Title>

      <Signature onSuccess={onSuccess} isSubmitting={isSubmitting} />
    </>
  )
}
